var map = {
	"./aprovavp/horizontal-logo.svg": 30301,
	"./backupDemo/horizontal-logo.svg": 42601,
	"./brasilstartups/horizontal-logo.svg": 26899,
	"./caboverde/horizontal-logo.svg": 30741,
	"./canaleducacao/horizontal-logo.svg": 24222,
	"./demo/horizontal-logo.svg": 20467,
	"./egepi/horizontal-logo.svg": 6904,
	"./encceja/horizontal-logo.svg": 64039,
	"./fic/horizontal-logo.svg": 89766,
	"./floriano-educa-7/horizontal-logo.svg": 29255,
	"./iesb/horizontal-logo.svg": 27163,
	"./infantil/horizontal-logo.svg": 7793,
	"./inkluziva/horizontal-logo.svg": 13833,
	"./kubi/horizontal-logo.svg": 15633,
	"./maiseducacao/horizontal-logo.svg": 64191,
	"./oab/horizontal-logo.svg": 55954,
	"./oros/horizontal-logo.svg": 97683,
	"./pit/horizontal-logo.svg": 24983,
	"./powerforgirls/horizontal-logo.svg": 82845,
	"./quartosecretariado/horizontal-logo.svg": 82474,
	"./retina/horizontal-logo.svg": 97979,
	"./seducpi/horizontal-logo.svg": 64885,
	"./sett-solutions/horizontal-logo.svg": 48585,
	"./siape/horizontal-logo.svg": 32052,
	"./tjpara/horizontal-logo.svg": 86677,
	"./unisescoop/horizontal-logo.svg": 15796,
	"./vegalabs/horizontal-logo.svg": 74977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91482;